<template>
  <div id="capa">
    <center> 
      <br v-if="isMobile">
     <b-row class="justify-content-center" :style="isMobile ? '' : 'margin-top:-48px;'">
      <b-col cols="12" md="5" lg="12" xl="12"> 
            <div data-aos="flip-left" data-aos-delay="350"     data-aos-duration="800"> 
              <img src="img/rifado_acceso.png" class="rounded mt-2" alt="Image" :style="isMobile ? 'width:90%;' : 'width:38%;'">
            </div> 
      </b-col>
     </b-row> 
     <br v-if="isMobile"><br v-if="isMobile"> 
      <div data-aos="zoom-in" data-aos-delay="1000"     data-aos-duration="700" >
        <p  :style="isMobile ? 'font-size:20px; color:#ffffff;  margin-top:-21px;' : 'font-size:22px; color:#ffffff;  margin-top:-21px;'">
            Pásele a lo barrido:
        </p>  
      </div>
       <b-row class="justify-content-center" :style="isMobile ? 'margin-top: -30px;' : 'margin-top: -30px;'">  
         <b-form aria-autocomplete="false"> 
            <b-col cols="8" md="4" lg="2" xl="2" >
              <br>
               <div data-aos="zoom-in"  data-aos-delay="650"     data-aos-duration="700"    > 
                <b-form-input placeholder="Email" v-model="email"  type="text"  class=" text-center"  style="border-radius: 30px; background: #fff; border: 2px solid #ccc; font-size: 17px;"/>
                <b-form-input v-model="mrt" placeholder="MRT"   type="text"  class=" text-center mt-4"  style="border-radius: 30px; background: #fff; border: 2px solid #ccc; font-size: 17px;"/> 
               </div>
            </b-col> 
            <b-col cols="12" md="5" lg="6" xl="6" class="mt-4" >    

                <u style="color:#0c273a;  cursor: pointer; font-size:18px; " @click="regresaLogin()">Seleccionar otro canal</u> 
                <br> 
                <p  style="color:#fff;" class=" mt-5" v-if="errors.includes( 'sesion' )"><b v-if="perfil == 5">IDPDV/AXC/MRT y/o email incorrectos.</b><b v-else>AXC/MRT y/o email incorrectos.</b></p>
                <div class="text-center" v-if="perfil != 0">
                    <p  style="color:#fff;"  class=" mt-5" v-if="errors.includes( 'sesion' )"><b>Password y/o email incorrectos.</b></p> 
                    <p  style="color:#fff;"  class=" mt-5" v-if="errors.includes( 'sesion' )"><b>Revisa si tu usuario pertenece a este canal.</b></p> 
                </div>

                <img src="img/ingresar.png" class="rounded mt-4" alt="Image" :style="isMobile ? 'width:50%;' : 'width:20%; cursor:pointer;'"  @click="login()" > 
                <b-spinner v-if="loader" small></b-spinner>  
            </b-col>
         </b-form>
       </b-row>   
       <br>
       <div data-aos="zoom-in" data-aos-delay="1000"     data-aos-duration="700" >
         <img src="img/orgullomexa.png" class="rounded"  alt="Image" :style="isMobile ? 'width:85%;' : 'width:20%;'"> 
        </div>
       <!-- <p class="text-white" v-if="perfil == 0">Si presentas problemas con tu ingreso; <u style="color:#0c273a; cursor: pointer;" @click="abrirContacto()">Contáctanos</u></p> -->
              <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" :style="isMobile ? 'width:12%;' : 'width:4%; margin-left:55px; margin-top:-450px;'"> 
              <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" :style="isMobile ? 'width:12%;' : 'width:4%; margin-left:1455px; margin-top:-650px;'" v-if="!isMobile">  
              <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" :style="isMobile ? 'width:12%;' : 'width:4%; margin-left:1225px; margin-top:-50px;'" v-if="!isMobile">   
     </center>
     <br> 
  </div>
</template>

<script>
  // import Multiselect from 'vue-multiselect'
// import $ from "jquery";
// import InitController from "@/utils/InitController";
import $ from "jquery";
export default {
  name: 'Inicio',
  //  components: { Multiselect },
  props:["perfil"],
  data(){
    return{
      isMobile: this.$mobile(), 
      idpdv:"",
      email:"",
      mrt:"",
      errors:[],
      loader:false,
      agencia:0,
      cadena:0,
      arrayAgencia:[],
      arrayCadena:[],
      arrayPdv:[],
      canal:0,
      correo:"",
      descripcion:"",
      options: [
          { value: 0, text: 'Seleccione el canal al que pertenece' },
          { value: 1, text: 'Retail' },
          { value: 2, text: 'TLMKT' },
          { value: 3, text: 'Propio' },
        ],
      enviar:false,
      val:0,
      vertical:0
    }
  },
  computed:{
      listadoCadena(){

        if (this.cadena == 0) {          
            return this.arrayPdv;
        }else{
               return   this.arrayPdv.filter(item => {
                    return  item.agencia?.toLowerCase().includes(this.agencia.toLowerCase()) &&
                            item.cadena?.toLowerCase().includes(this.cadena.toLowerCase()) 
                    ;
              });
        }
      }
  },
  methods:{
    regresaLogin(){
        this.$bus.$emit("regresa_login");
    },
    seleccionarCanal(){ 
      this.idpdv = "";
      this.mrt = "";
      this.agencia = 0;
      this.cadena = 0;
      this.errors = [];
      this.email = "";
      this.val = 0; 
    },
    apibitacora(){   
     this.$api.post('auth/bitacora', {
          'correo' : this.email,
          'mrt' : this.mrt,
          'canal' : this.perfil,
          'perfil' : "",
          'region' : 'N/A',
          'url' : '/',
          'seccion' : 'Login',
          'accion' : 'Inicio sesión',
          'detalle' : 'Accedio a la convención',
        }).then(
          response => {
             console.log(response);
          })
    },
    login() { 
        this.errors = []; 
        let model = this.prepareModel()

        this.loader = true;
        let request = this.$api.post("auth/login", model);
        request.then(
            response => {   
                console.log(response)      
                this.loader = false;  
                
                    if (response.data.sesion == 0)
                    {
                        this.val = response.data.val;
                        this.mrt = "";
                        this.errors.push('sesion');       
                    }else{ 
                        this.$store.dispatch("setLogin", response.data); 
                        this.$bus.$emit("fondo_capa", "fondoCapa")
                        this.$router.push("/");  
                        // InitController.startMetrics(response.data);
                        this.apibitacora();
                        
                    }
                
            },
            error => {
                this.loader = false;
                console.log(error);
            }
        )
            
    },
    prepareModel() {
        let model = new FormData();
        model.append("idpdv", this.idpdv)
        model.append("email", this.email)
        model.append("mrt", this.mrt)
        model.append("cadena", this.cadena)
        model.append("agencia", this.agencia)
        model.append("perfil", this.perfil)
        return model;
    },
    selectores(){
      var url= 'auth/selectores';
        this.$api.get(url).then(
            ({data}) => {
                console.log(data);
                this.arrayAgencia = data.agencia;    
                this.arrayCadena = data.cadena;   
                this.arrayPdv = data.pdv;   
            }
        );
    },
    abrirContacto(){
      this.$bvModal.show('contactoAyuda');
    },
    cerrarModal(){
      this.correo = "";
      this.descripcion = "";
      this.canal = 0;
      this.errors = [];
      this.$bvModal.hide('contactoAyuda');
    },
    ayuda(e) {
       e.preventDefault();
        this.errors = [];
        let model = this.prepareModel2()
        
        if(this.canal == 0){
            this.errors.push('canal');     
        }else if (!this.correo){
            this.errors.push('email');       
        }else if(!this.descripcion){
            this.errors.push('descripcion');
        }else{
            this.loader = true;
            let request = this.$api.post("auth/ayuda", model);
            request.then(
                response => {   
                    console.log(response)      
                    this.loader = false;  
                    this.canal = 0;
                    this.correo = "";
                    this.descripcion = ""; 
                    this.enviar = true;          
                },
                error => {
                    this.loader = false;
                    console.log(error);
                }
            )
        }
    },
    prepareModel2() {
        let model = new FormData();
        model.append("canal", this.canal)
        model.append("correo", this.correo)
        model.append("descripcion", this.descripcion)
        return model;
    },
  },
  mounted(){
  var height  = $(window).height();
     console.log(height);
     
     if (height < 950 && !this.isMobile)
     {
        const elem2 = document.getElementById("capa");
         elem2.style.zoom='90%';  

        // this.$bus.$emit("ajusta_zoom")
     }  

     if (window.orientation == '90' && this.isMobile || window.orientation == '-90'  && this.isMobile )
     {
       this.vertical = 1;
     }
     
      window.AOS.init(); 
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style> 